import { fork } from 'redux-saga/effects'
import apiSaga from './api'

export default function * init () {
  yield fork(apiSaga().watcher)
}



// WEBPACK FOOTER //
// ./src/sagas/initializer.js